module.exports = __webpack_public_path__ + "img/office6_7-8-2021.11620e7a.jpg";